import React from "react";
import _ from "lodash";

import TextField from "@material-ui/core/TextField";

import {useStyles} from "../styles";
import clsx from "clsx";
import {BaseNumberFormat} from "../../../../../../../components/Inputs";

export const DECIMAL_SCALE = 2;

export const NumberFormat = (props) => <BaseNumberFormat {...props} decimalScale={DECIMAL_SCALE} placeholder={'0,00'} />

export const CurrencyNumberFormat = (props) => {
  const {withSuffix, withPlaceholder, placeholder, ...rest} = props;

  return (
    <BaseNumberFormat
      {...rest}
      decimalScale={DECIMAL_SCALE}
      suffix={withSuffix ? " €" : undefined}
      placeholder={withPlaceholder ? placeholder ? placeholder : '0,00 €' : undefined}
    />
  );
};

CurrencyNumberFormat.defaultProps = {
  withSuffix: true,
  withPlaceholder: true
};

export const PercentageNumberFormat = (props) => {
  return (
    <BaseNumberFormat
      {...props}
      decimalScale={DECIMAL_SCALE}
      suffix=" %"
      placeholder={'0,00 %'}
    />
  );
};

const InputFormElement = props => {
  const {
    label,
    required,
    value,
    disabled,
    inputComponent,
    onChange,
    type,
    custom_classes,
    inputProps,
    error,
    helperText,
    multiline,
    placeholder,
    onKeyDown,
    inputComponentProps,
    onBlur,
    dataId,
  } = props;

  const classes = useStyles();

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  const handleBlur = () => onBlur && onBlur();

  const inputProperties = {
    ...inputProps,
    ...{
      inputComponent: inputComponent,
      classes: {
        root: clsx(classes.inputRoot, custom_classes && custom_classes.inputRoot),
        focused: classes.inputFocused,
      }
    }
  };

  return (
    type === 'hidden' ? <TextField value={value} type={type} data-id={dataId} /> :
      <TextField
        data-id={dataId}
        label={label}
        required={required}
        disabled={disabled}
        value={!_.isNil(value) ? value : ''}  // pass '' in case null/undefined to keep input "controlled"
        onChange={handleChange}
        onClick={(event) => event.stopPropagation()}
        onBlur={handleBlur}
        type={type}
        multiline={multiline}
        error={!!error}
        helperText={error || helperText}
        placeholder={placeholder || ''}
        onKeyDown={onKeyDown}
        classes={{
          root: clsx(classes.textFieldRoot, custom_classes && custom_classes.textFieldRoot)
        }}
        inputProps={inputComponentProps}
        InputProps={inputProperties}
        InputLabelProps={{
          shrink: true,
          classes: {
            root: clsx(classes.labelRoot, custom_classes && custom_classes.labelRoot),
            focused: classes.labelFocused,
            asterisk: classes.labelAsterisk
          }
        }}
        style={props.customStyle}
      />
  )
};

export default InputFormElement;